import * as React               from "react";
import { Component, ReactNode } from "react";
import { connect }              from "react-redux";
import MenuType                 from "../../domain/menu/MenuType";
import MenuList                 from "../components/menu/MenuList";

interface Props {
  menuType: MenuType;
}

class MenuContainer extends Component<Props> {
  public render(): ReactNode {
    const {menuType} = this.props;
    return (
      <>
        <MenuList
          menuType={ menuType }
        />
      </>
    );
  }
}

export default connect()(MenuContainer);
